
export default `

`.trim();



/** WEBPACK FOOTER **
 ** ./src/notes/event4.md.js
 **/